/**
 * @generated SignedSource<<886c7318f341217466c1018e9d17d075>>
 * @relayHash 6705315e840bf99cd995aca127ecae9d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4898a537f3247712af5e133ff02a49c5e55fe16d19a7ff8deb791c8535da3bc0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BacklogAggAppDataQuery } from './BacklogAggAppDataQuery.graphql';

const node: PreloadableConcreteRequest<BacklogAggAppDataQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "4898a537f3247712af5e133ff02a49c5e55fe16d19a7ff8deb791c8535da3bc0",
    "metadata": {},
    "name": "BacklogAggAppDataQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
